import { render, staticRenderFns } from "./LinkBuyersDialog.vue?vue&type=template&id=82e83814"
import script from "./LinkBuyersDialog.vue?vue&type=script&lang=js"
export * from "./LinkBuyersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports